import Main from '../../views/main'
export default [
  /* -------------- 系统文档 ----------- */
  {
    path: '/documents',
    component: Main,
    name: 'Documents',
    meta: {
      disabled: true,
      label: '文档'
    },
    children: [
      {
        name: 'ComponentsDoc',
        path: 'components',
        component: () => import(/* webpackChunkName: "test" */ '@/views/Documents/componentsDoc'),
        meta: {
          label: '通用组件',
          icon: 'mdi-file-document-box-multiple'
        }
      },
      {
        name: 'FunctionsDoc',
        path: 'functions',
        component: () => import(/* webpackChunkName: "test" */ '@/views/Documents/functionsDoc'),
        meta: {
          label: '通用函数',
          icon: 'mdi-function'
        }
      },
      {
        name: 'StoreDoc',
        path: 'store',
        component: () => import(/* webpackChunkName: "test" */ '@/views/Documents/storeDoc'),
        meta: {
          label: '通用状态',
          icon: 'mdi-function-variant'
        }
      },
    ]
  },
]
